import field from "./field/index.jsx";
import sewer from "./sewer/index.jsx";
import emptiness from "./emptiness/index.jsx";
import mountain from "./mountain/index.jsx";
import jungle from "./jungle/index.jsx";
import ice from "./ice/index.jsx";
import common from "./common/index.jsx";

export default { common, field, emptiness, jungle, mountain, ice, sewer };
